import * as types from "../../types";
import { API_URL } from "../../utils/constants";
import { displayMessages, setSavingState } from "../Layout/actions";
import { createAxiosInstance, validateModel } from "../../utils/helpers";
import { tableActions } from '@mawesi-sas/mws_react_component_table';
import history from "../../utils/history";
import { toast } from "react-toastify";
import Solicitud from "../Solicitud";

export function inicializarEstado() {
  return (dispatch, getState) => {
    const user = getState().signin.get("user");
    dispatch({
      type: types.NUEVASOLICITUD_INICIALIZAR_ESTADO,
      payload: {
        user,
      },
    });
  };
}

export function reiniciarEstado() {
  return (dispatch) => {
    dispatch({
      type: types.NUEVASOLICITUD_REINICIAR_ESTADO,
    });
  };
}

export function eliminarDetalle() {
  return (dispatch) => {
    dispatch({
      type: types.NUEVASOLICITUD_ELIMINAR_DETALLE,
    });

    dispatch({
      type: types.NUEVASOLICITUD_RECALCULAR_TOTAL_SOLICITUD,
    });
  };
}

export function eliminarRecurso() {
  return (dispatch) => {
    dispatch({
      type: types.NUEVASOLICITUD_ELIMINAR_RECURSO,
    });
  };
}

export function obtenerParametro(param) {
  const axios = createAxiosInstance();
  return (dispatch) => {
    axios
      .get(`${API_URL}/parametros?nombre=${param}`)
      .then((res) => {
        const fn1 = (d) =>
          d({
            type: types.NUEVASOLICITUD_POBLAR_PARAMETROS,
            payload: {
              parametro: param.toLowerCase(),
              data: res.data,
            },
          });
        fn1(dispatch);
      })
      .catch((err) => {
        displayMessages(dispatch, err);
      });
  };
}

export function showHideModalAdicionarCencos(show = false, id = null) {
  return (dispatch) => {
    dispatch({
      type: types.NUEVASOLICITUD_MOSTRAR_MODAL_ADICIONAR_CENCOS,
      payload: {
        show,
        id,
      },
    });
  };
}

export function actualizarDetalles() {
  return (dispatch, getState) => {
    const data = {
      _enabled: true,
      ...getState()
        .nuevasolicitud.getIn(`modalAdicionarDetalle.data`.split("."))
        .toJS(),
    };
    const valor_maximo = getState().nuevasolicitud.getIn(
      `modalAdicionarDetalle.data.valor_maximo`.split(".")
    );

    const modelState = validateModel(data, [
      {
        key: "tipo_servicio",
        conditions: "required",
      },
      {
        key: "tipo_producto",
        conditions: "required",
      },
      {
        key: "menu",
        conditions: "required",
      },
      {
        key: "cantidad",
        conditions: "required|number|min:1",
      },
      {
        key: "valor_unitario",
        conditions: `required|number||min:0|max:${valor_maximo}`,
      },
      {
        key: "valor_fijo",
        conditions: "required",
      },
      {
        key: "subtotal",
        conditions: `required`,
      },
    ]);

    if (modelState.length > 0) {
      modelState.forEach((x) => {
        toast.warn(x.message);
      });
      return;
    }

    if (data.id3n71f13r) {
      dispatch({
        type: types.NUEVASOLICITUD_ACTUALIZAR_DETALLES,
      });
    } else {
      dispatch(
        tableActions.mwsTable_agregarRegistros(
          "nuevasolicitud",
          "detalles",
          data
        )
      );
    }
    dispatch({
      type: types.NUEVASOLICITUD_RECALCULAR_TOTAL_SOLICITUD,
    });
    dispatch(
      tableActions.mwsTable_recalcularAnchoColumnas(
        "nuevasolicitud",
        "distribuciones"
      )
    );
    dispatch(showHideModalAdicionarDetalles(false));
  };
}

export function showHideModalAdicionarDetalles(show = false, id = null) {
  const axios = createAxiosInstance();
  return (dispatch, getState) => {
    if (!show) {
      dispatch({
        type: types.NUEVASOLICITUD_MOSTRAR_MODAL_ADICIONAR_DETALLES,
        payload: {
          show,
        },
      });
      return;
    }

    axios
      .get(`${API_URL}/tiposervicios`)
      .then((res) => {
        const tipos_servicio = res.data;
        let tipos_producto = [];
        if (id) {
          const current_data = getState().nuevasolicitud.getIn(
            `detalles.data.${id}`.split(".")
          );
          tipos_producto = current_data.getIn("tipos_producto".split("."));
        }

        dispatch({
          type: types.NUEVASOLICITUD_MOSTRAR_MODAL_ADICIONAR_DETALLES,
          payload: {
            show,
            lists: {
              tipos_servicio,
              tipos_producto,
            },
            id,
          },
        });
        dispatch(calcularTotalDetalle());
      })
      .catch((err) => {
        displayMessages(dispatch, err);
      });
  };
}

export function actualizarDistribuciones() {
  return (dispatch, getState) => {
    const data = {
      _enabled: true,
      ...getState()
        .nuevasolicitud.getIn(`modalAdicionarCenco.data`.split("."))
        .toJS(),
    };

    const modelState = validateModel(
      data,
      [
        {
          key: "cenco",
          conditions: "required|unique:distribuciones.data",
        },
        {
          key: "porcentaje",
          conditions: "required|number|min:0|max:100",
        },
      ],
      getState().nuevasolicitud
    );

    if (modelState.length > 0) {
      modelState.forEach((x) => {
        toast.warn(x.message);
      });
      return;
    }

    if (data.id3n71f13r) {
      dispatch({
        type: types.NUEVASOLICITUD_ACTUALIZAR_DISTRIBUCIONES,
      });
    } else {
      dispatch(
        tableActions.mwsTable_agregarRegistros(
          "nuevasolicitud",
          "distribuciones",
          data
        )
      );
    }

    dispatch({
      type: types.NUEVASOLICITUD_RECALCULAR_TOTAL_SOLICITUD,
    });
    dispatch(
      tableActions.mwsTable_recalcularAnchoColumnas(
        "nuevasolicitud",
        "distribuciones"
      )
    );
    dispatch(showHideModalAdicionarCencos(false));
  };
}

export function cargarOpcionesTipoServicio(selection) {
  return (dispatch, getState) => {
    const tipos_servicio = getState().nuevasolicitud.getIn(
      "modalAdicionarDetalle.data.tipos_servicio".split(".")
    );
    selection = tipos_servicio
      .filter((x) => x.get("nombre") === selection)
      .first();
    dispatch({
      type: types.NUEVASOLICITUD_POBLAR_OPCIONES_TIPO_SERVICIO,
      payload: {
        lists: {
          tipos_producto: selection.get("tipos_producto"),
        },
      },
    });
    dispatch(calcularTotalDetalle());
  };
}

export function cargarValoresTipoProducto(selection) {
  return (dispatch, getState) => {
    const tipos_producto = getState().nuevasolicitud.getIn(
      "modalAdicionarDetalle.data.tipos_producto".split(".")
    );
    selection = tipos_producto
      .filter((x) => x.get("nombre") === selection)
      .first();
    const lists = {
      descripcion: selection.get("descripcion"),
      valor_maximo: selection.get("valor_maximo"),
      valor_fijo: selection.get("valor_fijo"),
      preaprobacion: true,
    };
    if (lists.valor_fijo) lists.valor_unitario = lists.valor_maximo;

    dispatch({
      type: types.NUEVASOLICITUD_POBLAR_OPCIONES_TIPO_SERVICIO,
      payload: {
        lists,
      },
    });
    dispatch(calcularTotalDetalle());
  };
}

export function calcularTotalDetalle() {
  return (dispatch, getState) => {
    const valor_unitario =
      getState().nuevasolicitud.getIn(
        "modalAdicionarDetalle.data.valor_unitario".split(".")
      ) || null;
    const cantidad =
      getState().nuevasolicitud.getIn(
        "modalAdicionarDetalle.data.cantidad".split(".")
      ) || null;
    const tipo_producto = getState().nuevasolicitud.getIn(
      "modalAdicionarDetalle.data.tipo_producto".split(".")
    );
    const tipos_producto = getState().nuevasolicitud.getIn(
      "modalAdicionarDetalle.data.tipos_producto".split(".")
    );
    const selection = tipos_producto
      .filter((x) => x.get("nombre") === tipo_producto)
      .first();

    let subtotal = null;
    if (valor_unitario && cantidad) {
      subtotal = valor_unitario * cantidad;
    }
    dispatch({
      type: "HYQ3_MODIFY_INPUT_VALUE",
      payload: {
        reducer: "nuevasolicitud",
        path: "modalAdicionarDetalle.data.subtotal",
        value: subtotal,
      },
    });
    let preaprobacion = false;
    if (selection) {
      preaprobacion = valor_unitario <= selection.get("valor_maximo");
    }
    dispatch({
      type: "HYQ3_MODIFY_INPUT_VALUE",
      payload: {
        reducer: "nuevasolicitud",
        path: "modalAdicionarDetalle.data.preaprobacion",
        value: preaprobacion ? "APROBADO" : "NO APROBADO",
      },
    });
  };
}

export function guardarSolicitud() {
  const axios = createAxiosInstance();
  return (dispatch, getState) => {
    dispatch({
      type: types.NUEVASOLICITUD_LOADING,
      payload: true,
    });

    dispatch(setSavingState("nuevasolicitud", true));
    let solicitud = getState().nuevasolicitud;
    solicitud = solicitud.delete("modalAdicionarCenco");
    solicitud = solicitud.delete("modalAdicionarDetalle");
    solicitud = solicitud.delete("cafeterias");
    solicitud = solicitud.delete("saving");
    solicitud = solicitud.delete("dias_anti");
    solicitud = solicitud.delete("dias_festivos");
    solicitud = solicitud.set(
      "detalles",
      solicitud.getIn("detalles.data".split(".")).valueSeq()
    );
    solicitud = solicitud.set(
      "distribuciones",
      solicitud.getIn("distribuciones.data".split(".")).valueSeq()
    );
    solicitud = solicitud.set(
      "fecha_hora",
      `${solicitud.getIn("fecha".split("."))} ${solicitud.getIn(
        "hora".split(".")
      )}`
    );
    solicitud = solicitud.set(
      "cafeteria",
      solicitud.get("cafeteria") ? JSON.parse(solicitud.get("cafeteria")) : {}
    );

    solicitud = solicitud.set(
      "fecha_limite_aprobacion",
      solicitud.get("fecha_limite_aprobacion")
    );
    axios
      .post(`${API_URL}/solicitudes`, solicitud)
      .then((res) => {
        dispatch(setSavingState("nuevasolicitud", false));
        dispatch({
          type: types.NUEVASOLICITUD_LOADING,
          payload: false,
        });
        displayMessages(dispatch, {
          success: "Los registros han sido guardados exitosamente",
        });
        history.push(`${window.FOLDER}/solicitudes`);
      })
      .catch((err) => {
        dispatch(setSavingState("nuevasolicitud", false));
        dispatch({
          type: types.NUEVASOLICITUD_LOADING,
          payload: false,
        });
        displayMessages(dispatch, err);
      });
  };
}

export function llamarMensajesAlerta(mensaje) {
  return (dispatch) => {
    displayMessages(dispatch, {
      warning: mensaje,
    });
  };
}

export function resetField(campo) {
  return (dispatch) => {
    dispatch({
      type: types.NUEVASOLICITUD_REINICIAR_CAMPO,
      payload: campo,
    });
  };
}
